import React from 'react';
import Facebook from '../../../assets/images/Cedent/Facebook.png';
import twitter from '../../../assets/images/Cedent/twitter.png';
import googleplus from '../../../assets/images/Cedent/googleplus.png';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/dist/dropdown';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../../configs/constants';


export default function AppNavBar() {
  const navigate = useNavigate();
  return (
    <div className='bg-white'>
      <div className='d-flex mx-0 align-items-center'>
        <div className='col-md-5 col-sm-10 text-center  py-3'>
          <span>Follow us on : </span>
          <img src={Facebook} alt="" className='mx-3 AppHeader-social-icon' />
          <img src={twitter} alt="" className='mx-3 AppHeader-social-icon' />
          <img src={googleplus} alt="" className='mx-3 AppHeader-social-icon' />
        </div>
        <div className='col-md-7 col-sm-2'>
          <nav className="navbar navbar-expand-lg navbar-light bg-white py-3">
            <div className="container-fluid">
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                  <li className="nav-item mx-3">
                    <a className="nav-link"  role="button"  onClick={()=>navigate(paths.accounts.homePageLogin)}>
                      Home
                    </a>
                  </li>
                  <li className="nav-item mx-3">
                    <a className="nav-link" href="#">
                      About Us
                    </a>
                  </li>
                  <li className="nav-item mx-3">
                    <a className="nav-link" href="#">
                      Contact Us
                    </a>
                  </li>
                  <li className="nav-item mx-3">
                    <a className="nav-link" href="#">
                      My Account
                    </a>
                  </li>
                  <li className="nav-item dropdown mx-3">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      English
                    </a>
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li>
                        <a className="dropdown-item" href="#">
                          Action
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Another action
                        </a>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Something else here
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  )
}
